import angular from 'angular'
import StoryAccessDeniedComponent from './storyAccessDenied.component'
import StoryAccessDeniedController from './storyAccessDenied.controller'

export default angular
  .module('ellipsis.storyAccessDenied', [])
  .component('storyAccessDenied', StoryAccessDeniedComponent)
  .controller('StoryAccessDeniedController', StoryAccessDeniedController)
